<script setup lang="ts"></script>

<template>
  <icon name="lucide:search" />
</template>

<style scoped></style>
